import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => {
  return {
    wrapperAllCourse: {
      display: "flex",
      flexDirection: "column",
      gap: "12px",
    },
    wrapperHeaderDialog: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
    },
    containerLeftSideHeader: {
      display: "flex",
      flexDirection: "row",
      gap: "12px",
      alignItems: "center",
    },
    sectionCourses: {
      display: "flex",
      flexDirection: "column",
      gap: "12px",
    },
    wrapperImgProf: {
      width: "40px",
      height: "40px",
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    fullWidth: {
      width: "100%",
      height: "100%",
      borderRadius: "50%",
    },
    wrapperCourseRow: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
    },
    containerCourseTitle: {
      display: "flex",
      flexDirection: "row",
      gap: "6px",
      alignItems: "center",
    },
    containerAttatchment: {
      display: "flex",
      flexDirection: "row",
      gap: "4px",
    },
    fullWidthCancle: {
      width: "100%",
    },
  };
});
